<script setup>
    import { ref, reactive, onMounted } from 'vue';
    import Popper from 'vue3-popper';

    const props = defineProps({
        label: String,
        error: String,
        name: String,
        placeholder: String,
        modelValue: [String, null],
        type: { type: String, default: 'text' },
        hiddenLabel: { default: false, type: Boolean },
        tooltipEnabled: { default: false, type: Boolean },
    });

    const _value = ref(null);

    const emits = defineEmits([ 'update:modelValue' ]);

    onMounted(() => {
        if (props.modelValue) {
            _value.value = props.modelValue;
        }
    });
</script>

<template>
    <div>
        <label :class="{ 'opacity-0': hiddenLabel }" class="leading-loose inline-flex items-center font-avertaLight text-sm text-gray">
            <span class="font-avertaBold">{{ label }}</span>

            <Popper v-if="tooltipEnabled" style="display: inline-flex;" :hover="true">
                <icon name="info" class="ml-1"></icon>
                <template #content>
                    <div class="popper-client-admin"><slot name="tooltip"></slot></div>
                </template>
            </Popper>
        </label>

        <input
            v-model="_value"
            @input="$emit('update:modelValue', _value)"
            :name="name"
            :type="type"
            :placeholder="placeholder"
            :class="{ 'border-red': error }"
            class="mt-1 rounded-md ring-0 outline-none border-2 border-blue focus:border-blue-600 py-2 px-4 w-full font-avertaLight text-sm"/>

        <div v-if="error" class="mt-1 text-sm text-red">{{ error }}</div>
    </div>
</template>
